import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild} from '@angular/core';
import {Highlightable} from "@angular/cdk/a11y";
@Component({
  selector: 'valg-input-dropdown-option',
  template:
    `
      <span #contentWrapper>
        <ng-content></ng-content>
      </span>
    `,
  host: {
    'role': 'option',
    '[attr.aria-selected]': "selected"
  },
})
export class InputDropdownOptionComponent implements AfterViewInit, Highlightable {
  @Input() selected = false;
  @Output() selectionChange = new EventEmitter<void>();
  
  @ViewChild('contentWrapper') contentWrapper!: ElementRef;

  constructor(private elementRef: ElementRef){}

  ngAfterViewInit(): void {
    if (this.selected) {
      setTimeout(() => this.scrollToView(), 100);
    }
  }

  setActiveStyles() {
    this.scrollToView();
    this.selectionChange.emit();
  }

  setInactiveStyles() {
    this.selectionChange.emit();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.selectionChange.emit();
  }

  getLabel(): string {
    return this.contentWrapper.nativeElement.textContent.trim();
  }

  scrollToView() {
    this.elementRef.nativeElement.scrollIntoView({
      block: 'center',
    });
  }
}
